export const checkIfUserIsAllowToEdit = (features, role) => {
  const isAllow = true
  const isSupervisor = role == "supervisor"

  if (isSupervisor) {       
    features.forEach((feature) => {
      if (feature.name == "supervison_is_not_allow_to_edit") {
        isAllow = false
      }
    })
  }

  return isAllow
}